var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModerationQueue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Moderation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.08,7S22,6.28,20.84,5.88A12.85,12.85,0,0,1,16.33,3.6.5.5,0,0,0,16,3.46h0a.51.51,0,0,0-.36.14,12.38,12.38,0,0,1-4.49,2.28C10,6.28,6,7,5.92,7a.5.5,0,0,0-.42.49c0,8.1.1,11.84,2.58,15.65,2.12,3.26,7.5,5.24,7.73,5.33a.47.47,0,0,0,.17,0l.17,0c.23-.09,5.65-2.07,7.77-5.33,2.48-3.81,2.58-7.55,2.58-15.65A.5.5,0,0,0,26.08,7Zm-3,15.6c-1.74,2.67-6.18,4.5-7.1,4.86-.92-.36-5.32-2.19-7.06-4.86-2.2-3.38-2.41-6.4-2.42-14.69a47.94,47.94,0,0,0,5-1A16,16,0,0,0,16,4.61a16.1,16.1,0,0,0,4.53,2.22h0a48,48,0,0,0,5,1C25.49,16.16,25.28,19.18,23.08,22.56Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.32,16.47a.49.49,0,0,0-.7.05.51.51,0,0,0,.06.71l5,4.27a.47.47,0,0,0,.32.12h.07a.51.51,0,0,0,.35-.22l5.82-8.54a.5.5,0,0,0-.83-.57l-5.51,8.09Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerationQueue);
export default __webpack_public_path__ + "static/media/moderation-queue.67983dec880cf42400d34c421994e405.svg";
export { ForwardRef as ReactComponent };